(function () {
	if (window.__krownProductQtyLimitsReady) return;
	window.__krownProductQtyLimitsReady = true;

	const LIMITS = {
		'9494635053359': {
			max: 20,
			message: 'You can only add up to 20 of this item to your cart.',
		},
	};

	window.__KROWN_PRODUCT_QTY_LIMITS = LIMITS;

	window.__krownGetProductQtyLimit = function (productId) {
		if (!productId) return null;
		const entry = LIMITS[String(productId)];
		const limit = typeof entry === 'object' ? entry.max : entry;
		return Number.isFinite(limit) ? limit : null;
	};

	window.__krownGetProductQtyLimitMessage = function (productId) {
		const entry = LIMITS[String(productId)];
		if (entry == null) return '';
		if (typeof entry === 'object' && entry.message) {
			return entry.message;
		}
		const limit = window.__krownGetProductQtyLimit(productId);
		return limit == null ? '' : `You can only add up to ${limit} of this item to your cart.`;
	};

	window.__krownFetchCartQtyForProduct = async function (productId) {
		if (!productId || typeof KROWN === 'undefined') return 0;
		try {
			const res = await fetch(`${KROWN.settings.routes.cart_url}.js`, {
				headers: { Accept: 'application/json' },
				cache: 'no-store',
			});
			const cart = await res.json();
			return (cart.items || []).reduce((total, item) => {
				return String(item.product_id) === String(productId) ? total + item.quantity : total;
			}, 0);
		} catch (_) {
			return 0;
		}
	};

	window.__krownShowProductQtyLimitAlert = function (container, productId, itemEl) {
		const message = window.__krownGetProductQtyLimitMessage(productId);
		if (!message) return;

		if (container) {
			container.querySelectorAll('.alert--qty-limit').forEach((el) => el.remove());
			const alert = document.createElement('div');
			alert.classList.add('alert', 'alert--error', 'alert--qty-limit');
			alert.setAttribute('role', 'alert');
			alert.textContent = message;
			container.prepend(alert);
			alert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}

		if (itemEl) {
			itemEl.querySelectorAll('.cart-item__qty-limit-notice').forEach((el) => el.remove());
			const inline = document.createElement('p');
			inline.className = 'cart-item__qty-limit-notice text-size--small';
			inline.textContent = message;
			const host =
				itemEl.querySelector('.cart-item__actions') ||
				itemEl.querySelector('.cart-form-item__actions') ||
				itemEl;
			host.appendChild(inline);
		}
	};

	window.__krownClearProductQtyLimitAlert = function (container, itemEl) {
		container?.querySelectorAll('.alert--qty-limit').forEach((el) => el.remove());
		itemEl?.querySelectorAll('.cart-item__qty-limit-notice').forEach((el) => el.remove());
	};

	window.__krownGetSiblingProductQtyInForm = function (form, productId, excludeItemKey) {
		let total = 0;
		if (!form || !productId) return total;
		form.querySelectorAll('[data-js-cart-item]').forEach((el) => {
			if (String(el.dataset.productId) !== String(productId)) return;
			if (excludeItemKey && el.dataset.id === excludeItemKey) return;
			const q = parseInt(el.querySelector('.qty')?.value || el.dataset.qty, 10);
			if (Number.isFinite(q)) total += q;
		});
		return total;
	};

	window.__krownGetMaxQtyForCartLine = function (form, item) {
		const limit = window.__krownGetProductQtyLimit(item?.dataset?.productId);
		if (limit == null) return null;
		const otherQty = window.__krownGetSiblingProductQtyInForm(
			form,
			item.dataset.productId,
			item.dataset.id
		);
		return Math.max(0, limit - otherQty);
	};

	window.__krownClampCartItemQty = function (form, item, qty) {
		const limit = window.__krownGetProductQtyLimit(item?.dataset?.productId);
		if (limit == null || qty === 0) return qty;
		const maxForLine = window.__krownGetMaxQtyForCartLine(form, item);
		if (maxForLine <= 0) {
			return parseInt(item.dataset.qty, 10) || parseInt(item.querySelector('.qty')?.value, 10) || 1;
		}
		return Math.min(Math.max(1, qty), maxForLine);
	};

	window.__krownRefreshProductQtyLimitsInForm = function (form) {
		if (!form) return;
		form.querySelectorAll('[data-js-cart-item]').forEach((item) => {
			if (item.classList.contains('cart-item--freebie')) return;
			const qtyInput = item.querySelector('.qty');
			if (!qtyInput) return;
			const maxForLine = window.__krownGetMaxQtyForCartLine(form, item);
			if (maxForLine == null) return;
			if (maxForLine > 0) {
				qtyInput.setAttribute('max', String(maxForLine));
				const current = parseInt(qtyInput.value, 10);
				if (Number.isFinite(current) && current > maxForLine) {
					qtyInput.value = maxForLine;
				}
			} else {
				qtyInput.removeAttribute('max');
			}
		});
	};

	window.__krownApplyProductQtyLimitToInput = function (form, item, qtyInput) {
		if (!qtyInput || window.__krownGetProductQtyLimit(item?.dataset?.productId) == null) return;
		const maxForLine = window.__krownGetMaxQtyForCartLine(form, item);
		if (maxForLine == null) return;
		if (maxForLine > 0) {
			qtyInput.setAttribute('max', String(maxForLine));
			const current = parseInt(qtyInput.value, 10);
			if (Number.isFinite(current) && current > maxForLine) {
				qtyInput.value = maxForLine;
			}
		}
	};
})();
